module.exports = __webpack_public_path__ + "static/media/roku-img.91b998a7.png";